import {
    CommandLineInterface,
    consoleLogger,
    CoreDI,
    DebugStats,
    IBrowser,
    inject, injectable, IService,
    System, SystemComponentType
} from '@gongxigames/framework/core';

@injectable()
export class StatsService implements IService {
    public static NAME = 'StatsService';
    public type: SystemComponentType = 'service';

    @inject(CoreDI.CLI)
    private _cli!: CommandLineInterface;

    @inject(CoreDI.System)
    private _system!: System;

    @inject(CoreDI.Browser)
    private _browser!: IBrowser;

    private _debugStats?: DebugStats;

    public init(): void {
        this.initStats();

        this._cli.addCommand('emulate', () => this._browser.addTimeout(() => {
            const webglContext = this._system.app.view.getContext('webgl2', {})
                || this._system.app.view.getContext('webgl', {}) as any;

            if (webglContext) {
                consoleLogger.log('losing webgl context...');
                webglContext.getExtension('WEBGL_lose_context').loseContext();
            }
        }, 100));
    }

    public destroy(): void {
        this.destroyStats();
    }

    private initStats(): void {
        this._debugStats = new DebugStats();
        this._debugStats.init(this._system.renderer);
        this._system.ticker.add(this._debugStats.update, this._debugStats);
    }

    private destroyStats(): void {
        if (this._debugStats) {
            this._system.ticker.remove(this._debugStats.update, this._debugStats);
            this._debugStats.destroy();
        }
    }
}
